import Extent from '@arcgis/core/geometry/Extent.js';
import SpatialReference from '@arcgis/core/geometry/SpatialReference.js';
import JumpExtentWidget from './JumpExtentWidget';

const AlaskaWidget = ({ view }) => {
    const targetExtent = new Extent({
        xmin: -19430660.90751849,
        ymin: 6002448.621339999,
        xmax: -13665405.635740003,
        ymax: 12265255.002859998,
        spatialReference: new SpatialReference({ wkid: 3857 })
    });

    return <JumpExtentWidget id={'alaskaLink'} view={view} label={'Jump to Alaska'} extent={targetExtent} />;
};

export default AlaskaWidget;
